import CirclePhoneIcon from "@/Components/Icons/CirclePhoneIcon.vue";
import FacebookIcon from "@/Components/Icons/FacebookIcon.vue";
import FacebookMessengerIcon from "@/Components/Icons/FacebookMessengerIcon.vue";
import InstagramLogo from "@/Components/Icons/InstagramLogo.vue";
import LetterInCircleIcon from "@/Components/Icons/LetterInCircleIcon.vue";
import WhatsappLogo from "@/Components/Icons/WhatsappLogo.vue";

export default {
    CirclePhoneIcon,
    FacebookIcon,
    FacebookMessengerIcon,
    InstagramLogo,
    LetterInCircleIcon,
    WhatsappLogo,
};
